exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-component='transfer-confirmation'] [data-component='virtual-num-pad'] p {\n  font-weight: normal;\n  text-align: center;\n  margin-bottom: 20px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/transfers-other-banks/transfer-confirmation/transfer-confirmation.component.styl
// module id = ../../../../../src/app/master/transfers-other-banks/transfer-confirmation/transfer-confirmation.component.styl
// module chunks = main